/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Template_ClassicInputs */

const cs_public_site_template_classic = /** @type {(inputs: Public_Site_Template_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasický`)
};

const en_public_site_template_classic = /** @type {(inputs: Public_Site_Template_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classic`)
};

/**
* | output |
* | --- |
* | "Classic" |
*
* @param {Public_Site_Template_ClassicInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_template_classic = /** @type {((inputs?: Public_Site_Template_ClassicInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Template_ClassicInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_template_classic(inputs)
	return cs_public_site_template_classic(inputs)
});